import { CTAButtons } from "../../../../../global/components/Buttons/buttons";
import React, { useState, useEffect } from "react";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import Table from "../../../../Components/Table/Table";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { TableActionsNew } from "../../../../Components/Misc/Actions";
import "./style.css";
import {
  getFeeSetup,
  getExchangeRateSetup,
  createExchangeRateSetup,
  updateExchangeRateSetup,
} from "../../../../../../utils/redux/Finance/PaymentSetup/PaymentSetupSlice";
import { FiX, FiArrowLeft } from "react-icons/fi";
import DeclineModal from "../Components/DeclineModal";
import RouteLayout from "../../../../Components/Layout/RouteLayout";
import { toast } from "react-toastify";
import {
  FilterButton,
  ProDropFilter,
} from "../../../../Components/Search/Search";

// Table Headers format:
let mockHeaders = [
  {
    title: "Currency",
    key: "currency",
  },
  {
    title: "Exchange Rate Value",
    key: "actualExchangeRate",
  },
  {
    title: "Created By",
    key: "createdByName",
  },
  {
    title: "Status",
    key: "approvalStatus",
  },
  {
    title: "Actions",
    key: null,
  },
];

export default function ExchangeRateSetup() {
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [comment, setComment] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [currentType, setCurrentType] = useState(null);
  const [declineStatus, setDeclineStatus] = useState(false);

  const [selectedItems, setSelectedItems] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const exchangeRates = useSelector(
    (state) => state?.paymentSetup?.exchangeRates?.responseObject?.items || []
  );

  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [approvalStatus, setFilter] = useState("all");

  // Initialize state with the provided object values
  const initialState = {
    currency: "NGN",
    exchangeRateValue: 1,
    actualExchangeRate: 1,
  };

  const [formData, setFormData] = useState(initialState);

  // Handle change for input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const closeModal = () => {
    setOpenModal(false);
    setComment("");
    setDeclineStatus(false);
    setCurrentType(null); // Clear current type
  };

  const filterBy = [
    {
      name: "Pending",
      filter: 1,
    },
    {
      name: "Approved",
      filter: 2,
    },
    {
      name: "Declined",
      filter: 7,
    },
  ];

  let mockRowOptions = [
    {
      name: "Edit",
      action: (item) => {
        setCurrentType(item);
        setComment(item?.name);
        setOpenModal(true);
        setFormData({
          currency: item?.currency || "",
          exchangeRateValue: item?.exchangeRateValue || "1",
          actualExchangeRate: item?.actualExchangeRate || "1",
        });
      },
    },
    {
      name: "Approve",
      action: (item) => {
        const payload = {
          id: item?.id,
          status: 0,
        };
        // dispatch(approveWitholdingTaxSetup(payload)).then((response) => {
        //   if (response?.payload?.successful === true) {
        //     setRefresh(!refresh);
        //     toast.success(response?.payload?.statusMessage);
        //   } else {
        //     toast.error(response?.payload?.statusMessage);
        //   }
        // });
      },
    },
    {
      name: "Decline",
      action: (item) => {
        const payload = {
          id: item?.id,
          status: 7,
        };
        // dispatch(declineWitholdingTaxSetup(payload)).then((response) => {
        //   if (response?.payload?.successful === true) {
        //     setRefresh(!refresh);
        //     toast.success(response?.payload?.statusMessage);
        //   } else {
        //     toast.error(response?.payload?.statusMessage);
        //   }
        // });
      },
    },
  ];

  useEffect(() => {
    dispatch(
      getExchangeRateSetup({
        pageSize,
        pageNumber,
        ApprovalStatus: approvalStatus === "all" ? "" : approvalStatus,
      })
    );
  }, [approvalStatus, dispatch, pageNumber, pageSize, refresh]);

  const handleCreateFXSetup = async () => {
    if (
      !formData.currency ||
      !formData.exchangeRateValue ||
      !formData.actualExchangeRate
    ) {
      return toast.error("All fields are required");
    }
    // Handle creation logic
    const payload = {
      currency: formData.currency,
      exchangeRateValue: +formData.exchangeRateValue,
      actualExchangeRate: +formData.actualExchangeRate,
    };

    try {
      setLoading(true);
      let response;
      if (currentType) {
        // Editing existing
        response = await dispatch(
          updateExchangeRateSetup({
            id: currentType.id,
            ...payload,
          })
        );
      } else {
        // Creating new
        response = await dispatch(createExchangeRateSetup(payload));
      }
      if (response?.payload?.successful === true) {
        setRefresh(!refresh);
        toast.success(response?.payload?.statusMessage);
        setLoading(false);
        setOpenModal(false);
        setFormData(initialState);
      } else if (response?.payload?.successful === false) {
        toast.error(response?.payload?.statusMessage);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <RouteLayout>
      <button
        className="text-customGreen flex items-center gap-2 text-xl"
        onClick={() => {
          navigate(-1);
        }}
      >
        <FiArrowLeft />
        Back
      </button>

      <div className="w-full mt-5">
        {openModal && (
          <DeclineModal hideModal={setOpenModal}>
            <div
              className="bg-white w-full overflow-hidden"
              style={{
                borderTopLeftRadius: "5px",
                borderTopRightRadius: "5px",
              }}
            >
              <header className="w-full py-3 bg-customGreen px-4 flex items-center justify-between">
                <p className="text-white text-baseFont">
                  {declineStatus
                    ? "Reason for Delete"
                    : currentType
                    ? "Edit Exchange Rate Setup"
                    : "Add Exchange Rate Setup"}
                </p>
                <button
                  className="text-baseFont text-white"
                  onClick={closeModal}
                >
                  <FiX />
                </button>
              </header>
            </div>
            <section className="bg-white p-6">
              <div className="flex mt-6 mb-12 justify-between">
                <div className="flex gap-4 w-full">
                  <div className="flex flex-col gap-4 w-full">
                    {/* FEE SETUP */}
                    <div className="flex flex-col">
                      <div className="text-green-700 text-sm mb-1">
                        Currency
                        <span className="text-red-500">*</span>
                      </div>
                      <input
                        className="block w-full px-4 py-2 text-gray-700 border border-slate-300 bg-slate-50 text-sm rounded-md focus:outline-none focus:ring-0"
                        name="currency"
                        value={formData.currency || ""}
                        onChange={handleChange}
                      />
                    </div>

                    {/* PAYMENT TYPE */}
                    <div className="flex flex-col">
                      <div className="text-green-700 text-sm mb-1">
                        Exchange Rate Value
                        <span className="text-red-500">*</span>
                      </div>
                      <input
                        type="number"
                        className="block w-full px-4 py-2 text-gray-700 border border-slate-300 bg-slate-50 text-sm rounded-md focus:outline-none focus:ring-0"
                        name="exchangeRateValue" defaultValue={"1"}
                        value={formData.exchangeRateValue}
                        onChange={handleChange}
                      />
                    </div>

                    {/* PERCENTAGE */}
                    <div className="flex flex-col">
                      <div className="text-green-700 text-sm mb-1">
                        Actual Exchange Rate
                        <span className="text-red-500">*</span>
                      </div>
                      <input
                        type="number"
                        className="block w-full px-4 py-2 text-gray-700 border border-slate-300 bg-slate-50 text-sm rounded-md focus:outline-none focus:ring-0"
                        name="actualExchangeRate" defaultValue={"1"}
                        value={formData.actualExchangeRate}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full flex items-center justify-end gap-5 pt-3 px-7">
                <button
                  className="rounded-md py-1 px-4 text-baseFont text-customGreen"
                  style={{ border: "1px solid #305f32" }}
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button
                  disabled={loading}
                  className={`rounded-md py-1 px-4 text-baseFont ${
                    loading
                      ? "bg-gray-400 text-gray-700 border-gray-500 cursor-not-allowed"
                      : "bg-customGreen text-white border-customGreen"
                  }`}
                  style={{ border: "1px solid #305f32" }}
                  onClick={handleCreateFXSetup}
                >
                  {loading ? "Loading..." : currentType ? "Update" : "Proceed"}
                </button>
              </div>
            </section>
          </DeclineModal>
        )}

        <div
          className={`${DashboardStyle.dashboard_table_holder} rounded p-10 bg-white `}
        >
          <div className="w-full flex items-center justify-between mb-1">
            <h1 className="text-customGreen text-xl font-semibold">
              Exchange Rate Setup
            </h1>
            <CTAButtons
              onClick={() => {
                setOpenModal(true);
              }}
            >
              Add Exchange Rate Setup
            </CTAButtons>
          </div>
          <div className={DashboardStyle.dashboard_filter}>
            <ProDropFilter
              filter={approvalStatus}
              setFilter={setFilter}
              name={"Approval Status"}
              filterBy={filterBy}
              value={approvalStatus}
            />
            <FilterButton onClick={() => setRefresh(!refresh)} name="" />
          </div>
          <Table>
            <thead>
              <tr>
                <th>
                  <p>ID</p>
                </th>
                {mockHeaders.map((header) => (
                  <th key={header.key}>{header.title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <RequestTable
                isLoading={false}
                data={exchangeRates}
                keys={mockHeaders.map((header) => header.key)}
                selectable={true}
                rowOptions={mockRowOptions}
                selectedItems={selectedItems}
              />
            </tbody>
          </Table>
        </div>

        {/* <Pagination
          last_page={paymentTypes?.totalPages}
          present_page={paymentTypes?.currentPage}
          totalRows={paymentTypes?.totalRows}
          pageSize={pageSize}
          setPageSize={(page) => setPageSize(page)}
          click={(page) => setPageNumber(page)}
        /> */}
      </div>
    </RouteLayout>
  );
}

function RequestTable({ data, rowOptions }) {
  return (
    <>
      {data?.map((item, index) => (
        <tr key={item.id}>
          <td>
            <p>{index + 1}</p>
          </td>
          <td>{item.currency}</td>
          <td>{item.actualExchangeRate}</td>
          <td>{item.createdByName}</td>
          <td>{item?.approvalStatus}</td>
          <td>
            <TableActionsNew
              // url={`/dashboard/finance/${URL.ExchangeRateSetup}/${item.id}/view`}
              actions={rowOptions.map((option) => ({
                name: option.name,
                action: () => option.action(item),
              }))}
            />
          </td>
        </tr>
      ))}
    </>
  );
}
